import React, { useEffect, useState } from "react";
import { URLS } from "../../helpers/URLS";
import { Box, Button, FormControl, Grid, InputLabel, TextField, Select, MenuItem, IconButton, Tooltip } from "@mui/material";
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import '../../assets/scss/tables.scss';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import useAxios from "../../helpers/Hooks/useAxios";

const skillLevels = [
    { label: 'Beginner', value: 'Beginner' },
    { label: 'Intermediate', value: 'Intermediate' },
    { label: 'Advanced', value: 'Advanced' },
    { label: 'Expert', value: 'Expert' },
]

const skillpayload = {
    skills: [],
    desiredSkills: []
}

const newSkillItem = {
    name: "",
    level: "",
    _id: ""
}

const UserProfileSkills = (props) => {

    const { user, reloadProfile } = props;

    const { fetchData } = useAxios();

    const [skillsPayload, setSkillsPayload] = useState(skillpayload)

    const [newSkill, setNewSkill] = useState(newSkillItem)

    const [showSkillsForm, setShowSkillsForm] = useState(false);

    const [newDesiredSkill, setNewDesiredSkill] = useState('')

    const [showDesiredSkillsForm, setShowDesiredSkillsForm] = useState(false);

    useEffect(() => {
        if (user) {
            setSkillsPayload(
                {
                    ...skillsPayload,
                    skills: user.skills ? [...user.skills] : [],
                    desiredSkills: user?.desiredSkills ? [...user.desiredSkills] : []
                }
            )
        }
    }, [user])

    const handleFormItemChange = (name, value) => {
        setNewSkill(
            {
                ...newSkill,
                [name]: value
            }
        )
    }

    const saveSkills = () => {
        let allSkills = []
        if (newSkill._id) {
            allSkills = skillsPayload.skills.map(skill => {
                if (skill._id === newSkill._id) {
                    skill.name = newSkill.name;
                    skill.level = newSkill.level
                }
                return skill
            })
        } else {
            allSkills = [...skillsPayload.skills, { name: newSkill.name, level: newSkill.level }];
        }
        const reqPayload = {
            skills: allSkills,
            desiredSkills: [...skillsPayload.desiredSkills],
        }
        updateProfile(reqPayload);
    }

    const deleteSkill = (data) => {
        let allSkills = skillsPayload.skills.filter(skill => skill._id !== data._id);
        const reqPayload = {
            skills: allSkills,
            desiredSkills: [...skillsPayload.desiredSkills],
        }
        updateProfile(reqPayload);
    }

    const saveDesiredSkills = () => {
        const reqPayload = {
            ...skillsPayload,
            desiredSkills: [...skillsPayload.desiredSkills, newDesiredSkill],
        }
        updateProfile(reqPayload);
    }

    const deleteDesiredSkill = (item) => {
        let allDesiredSkills = skillsPayload.desiredSkills.filter(skill => skill !== item);
        const reqPayload = {
            ...skillsPayload,
            desiredSkills: allDesiredSkills,
        }
        updateProfile(reqPayload);
    }

    const updateProfile = async (reqPayload) => {
        const resp = await fetchData({ url: URLS.updateProfile, method: 'post', body: reqPayload })
        if (resp.status === 200) {
            reloadProfile();
            setNewSkill(newSkillItem);
            setShowSkillsForm(false);
        }
    }

    return (
        <div className="wh-table">
            <div className="wh-panel mb-3">
                <div className="wh-panel-head">
                    <h6 className="wh-section-title" style={{ margin: 0 }}>
                        <PsychologyOutlinedIcon />Current Skills
                    </h6>
                    {showSkillsForm ?
                        <Button variant="contained" size="small" onClick={saveSkills} disabled={newSkill.level === "" || newSkill.name === ""}> Save</Button> :
                        <Button variant="contained" size="small" onClick={() => { setShowSkillsForm(true) }}> Add</Button>}
                </div>
                {showSkillsForm ? <Box p={3} pt={1}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField fullWidth label="Skill Name" value={newSkill.name} variant="outlined"
                                onChange={(e) => handleFormItemChange('name', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="level">Skill Level</InputLabel>
                                <Select
                                    labelId="level"
                                    id="level"
                                    value={newSkill.level}
                                    onChange={(e) => handleFormItemChange('level', e.target.value)}
                                    label={'Skill Level'}
                                >
                                    {skillLevels.map(opt =>
                                        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box> : null}
                <div className="table-responsive wh-table-shell">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Skills</th>
                                <th scope="col">Level</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                skillsPayload && skillsPayload.skills.map((data, index) => (
                                    <tr key={index}>
                                        <td className="wh-col-shrink">{index + 1}</td>
                                        <td><span className="wh-pill">{data.name}</span></td>
                                        <td>{data.level}</td>
                                        <td className="wh-col-shrink wh-actions-2">
                                            <div className="wh-actions-row">
                                                <Tooltip title="Edit" placement="top" arrow>
                                                    <IconButton aria-label="Edit" onClick={() => {
                                                        setNewSkill({
                                                            name: data.name,
                                                            level: data.level,
                                                            _id: data._id
                                                        });
                                                        setShowSkillsForm(true);
                                                    }}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete" placement="top" arrow>
                                                    <IconButton className="wh-danger" aria-label="Delete"
                                                        onClick={() => deleteSkill(data)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </td>
                                    </tr>)
                                )
                            }
                        </tbody>
                    </table>
                </div>

            </div>
            <div className="wh-panel mb-3">
                <div className="wh-panel-head">
                    <h6 className="wh-section-title" style={{ margin: 0 }}>
                        <AutoAwesomeOutlinedIcon />Desired Skills
                    </h6>
                    {showDesiredSkillsForm ?
                        <Button variant="contained" size="small" onClick={() => {
                            saveDesiredSkills()
                            setShowDesiredSkillsForm(false)
                            setNewDesiredSkill('')
                        }}> Save</Button> :
                        <Button variant="contained" size="small" onClick={() => { setShowDesiredSkillsForm(true) }}>Add</Button>}
                </div>
                {
                    showDesiredSkillsForm ? <Box p={3} pt={1}>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Skill Name" value={newDesiredSkill} variant="outlined"
                                    onChange={(e) => { setNewDesiredSkill(e.target.value) }} />
                            </Grid>
                        </Grid>
                    </Box> : null
                }
                {skillsPayload.desiredSkills.length > 0
                    ? <div className="wh-pills">
                        {skillsPayload.desiredSkills.map((skill, index) =>
                            <span className="wh-pill wh-pill-removable" key={index}>
                                {skill}
                                <Tooltip title="Remove" placement="top" arrow>
                                    <button type="button" aria-label={`Remove ${skill}`}
                                        onClick={() => { deleteDesiredSkill(skill) }}>
                                        <ClearIcon />
                                    </button>
                                </Tooltip>
                            </span>
                        )}
                    </div>
                    : <p className="wh-section-empty">No desired skills added yet.</p>}
            </div>
        </div >
    )
}

export default UserProfileSkills